import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { teamActions } from "@fitness-app/app-store";

import NotFound from "~/components/NotFound/NotFound";
import { useAppDispatch } from "~/store/initializeStore";
import SupportBoard from "./SupportBoard";

const SupportRouter = () => {
  const dispatch = useAppDispatch();

  // Predefined request tags (trainer_config.supportRequestTags) for the form,
  // drawer and cards.
  useEffect(() => {
    void dispatch(teamActions.fetchTrainerConfig());
  }, [dispatch]);

  return (
    <Routes>
      <Route index element={<SupportBoard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SupportRouter;
